export default __webpack_public_path__ + "static/media/cote_divoire.33c07f30.svg";